import React from "react";
import { FaArrowRight } from "react-icons/fa";

const JoinAsRiderContainer = () => {
  return (
    <div
      className="flex gap-10 flex-col justify-center items-center mt-4 lg:mb-[119px] mb-24"
      id="join"
    >
      <div className="flex flex-col gap-4 justify-center items-center text-center lg:w-auto w-[287px]">
        <h2 className="lg:text-4xl text-[28px] font-semibold leading-[150%] text-[#364763]">
          Are You a <span className="text-[#E5204B]"> Rider? </span> Join Flit
          Today!
        </h2>
        <h4 className="text-[#606C80] font-medium lg:text-xl text-base">
          Earn more with zero commissions. Ride on your terms.
        </h4>
      </div>
      <button className="w-[353px] h-[60px] rounded-xl py-[18px] px-4 bg-[#E5204B] flex items-center justify-center gap-2 text-[#F7F9FA] text-lg font-semibold">
        Sign Up as a Rider
        <FaArrowRight />
      </button>
    </div>
  );
};

export default JoinAsRiderContainer;
